import http from './http'

/**
 * 玩法列表（顺序、展示名等由后端配置）
 * GET /api/lottery-types/list
 */
export function fetchLotteryTypesList(params) {
  return http.get('/api/lottery-types/list', { params })
}
